// extracted by mini-css-extract-plugin
export default {"toast":"comment_toast__nW2Z0"};